import axios from "axios";

const BASE_API_URL = `${window?.appConfig?.API_ENDPOINT}`;

// Old flow, not being used in current implementation
function login(clientId, clientSecret) {

    const requestObj = JSON.stringify({
        clientId: clientId,
        clientSecret: clientSecret
    });
    return axios.post(BASE_API_URL + '/token', requestObj, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};

function logout() {
    return axios.get(BASE_API_URL + `/api/logout`);
}


export default {
    login,
    logout
};